import React from 'react';
import PropTypes from 'prop-types';

import { usePrefs, useFlags } from 'wsm-common-data';

import vehiclePropType from '../../../../propTypes/vehiclePropType';
import { hasInTransitBadge } from '../../../../utilities/hasInTransitBadge';
import HighlightedAttributeContainer from '../HighlightedAttributeContainer';
import CTAButtons from '../CTAButtons';
import VehiclePackages from '../VehiclePackages';
import WebIntegrationVehiclePricingPlaceholder from '../WebIntegrationVehiclePricingPlaceholder';
import DetailedIncentivesContainer from '../DetailedIncentivesContainer';
import VehicleAttributeList from '../VehicleAttributeList';
import PricingElement from '../PricingElement';
import Callout from '../../Callout';

const ListView = ({
	accountId,
	accountInfo,
	highlightedAttributes,
	incentives,
	isDisplayingEPrice,
	setIsDisplayingEPrice,
	showExpandedPricing,
	showNewCarBoostPaymentsInDetails,
	setShowExpandedPricing,
	vehicle
}) => {
	const { showPackages, showIncentives } = usePrefs();
	const flags = useFlags();
	const {
		packages = [],
		link,
		callout: callouts,
		classification,
		type
	} = vehicle;

	return (
		<>
			<HighlightedAttributeContainer
				accountInfo={accountInfo}
				hasInTransitBadge={hasInTransitBadge(callouts)}
				highlightedAttributes={highlightedAttributes}
				vehicleClassification={classification}
				isNewCarBoost={!!vehicle.isNewCarBoost}
				isSpotlightedVehicle={!!vehicle.spotlightedVehicle}
				/* TODO: `vehicle.type` will always be a string once all sites are on WIS */
				vehicleType={type === 'new' || type === 2 ? 'new' : 'used'}
			/>
			<div className="d-md-flex">
				<div className="vehicle-card-info-packages w-100">
					<VehicleAttributeList vehicle={vehicle} />
					{showPackages === 'true' && (
						<VehiclePackages
							packages={packages}
							link={link}
							uuid={vehicle.uuid}
						/>
					)}
					{flags['ws-inv-listing-show-gallery-list-card'] && (
						<div className="d-flex">
							<Callout callouts={callouts} vehicle={vehicle} />
						</div>
					)}
				</div>
				<div className="vehicle-card-pricing w-100">
					<div className="w-100">
						<PricingElement
							accountId={accountId}
							accountInfo={accountInfo}
							incentives={incentives}
							isDisplayingEPrice={isDisplayingEPrice}
							setShowExpandedPricing={setShowExpandedPricing}
							showExpandedPricing={showExpandedPricing}
							showNewCarBoostPaymentsInDetails={
								showNewCarBoostPaymentsInDetails
							}
							vehicle={vehicle}
						/>
					</div>
					<div className="w-100">
						{showIncentives === 'true' && (
							<DetailedIncentivesContainer
								accountInfo={accountInfo}
								incentives={incentives}
								vehicle={vehicle}
							/>
						)}
					</div>
					<div className="w-100">
						<CTAButtons
							accountId={accountId}
							vehicle={vehicle}
							isDisplayingEPrice={isDisplayingEPrice}
							setIsDisplayingEPrice={setIsDisplayingEPrice}
						/>
					</div>
					<div className="w-100">
						<WebIntegrationVehiclePricingPlaceholder
							vehicle={vehicle}
							classNames="mt-3"
						/>
					</div>
				</div>
			</div>
		</>
	);
};

ListView.propTypes = {
	accountId: PropTypes.string.isRequired,
	accountInfo: PropTypes.shape({}),
	highlightedAttributes: PropTypes.arrayOf(PropTypes.shape({})),
	incentives: PropTypes.shape({}),
	isDisplayingEPrice: PropTypes.bool.isRequired,
	setIsDisplayingEPrice: PropTypes.func.isRequired,
	setShowExpandedPricing: PropTypes.func.isRequired,
	showExpandedPricing: PropTypes.bool.isRequired,
	showNewCarBoostPaymentsInDetails: PropTypes.bool,
	vehicle: vehiclePropType.isRequired
};

export default ListView;
